<template>
  <v-container fluid grid-list-md>
    <v-card class="pa-3">
      <v-layout wrap>
        <v-flex sm4>
          <v-text-field
            label="Name"
            v-model="a.name"
            :error-messages="nameErrors"
            required
            @input="$v.a.name.$touch()"
            @blur="$v.a.name.$touch()"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field
            label="Email"
            type="email"
            v-model="a.email"
            :error-messages="emailErrors"
            required
            @input="$v.a.email.$touch()"
            @blur="$v.a.email.$touch()"
            prepend-inner-icon="mdi-email"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field
            label="Telephone"
            v-model="a.telephone"
            prepend-inner-icon="mdi-phone"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex sm4>
          <languages-list
            :language-id="a.languageId"
            @onSelect="onLanguageSelect($event)"
            :outlined="outlinedInputs"
          ></languages-list>
        </v-flex>
        <v-flex sm4>
          <departments-list
            v-model="a.department"
            :outlined="outlinedInputs"
          ></departments-list>
        </v-flex>
        <v-flex sm2>
          <v-text-field
            label="Company Code"
            v-model="a.companyCode"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm2>
          <agent-type-list-select
            v-model="a.agentType"
            :outlined="outlinedInputs"
          ></agent-type-list-select>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex sm4>
          <v-text-field
            label="City"
            v-model="a.city"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm4>
          <v-text-field
            label="Region"
            v-model="a.region"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm2>
          <v-text-field
            label="State"
            v-model="a.state"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
        <v-flex sm2>
          <v-text-field
            label="Post/Zip Code"
            v-model="a.postCode"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12 sm6>
          <v-layout column>
            <v-flex xs12>
              <v-textarea
                label="Address"
                v-model="a.address"
                :outlined="outlinedInputs"
              ></v-textarea>
            </v-flex>
            <v-flex xs12>
              <v-textarea
                label="Notes"
                v-model="a.notes"
                :outlined="outlinedInputs"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-row>
            <v-col
              ><v-switch v-model="a.notInUse" label="Not in Use"></v-switch
            ></v-col>
            <v-col
              ><v-switch
                v-model="a.roundMarkups"
                label="Round Markups"
              ></v-switch
            ></v-col>
            <v-col
              ><v-switch
                v-model="a.roundDiscounts"
                label="Round Discounts"
              ></v-switch
            ></v-col>
          </v-row>
        </v-flex>
        <v-flex xs12 sm6 style="position: relative" class="px-2 pb-4">
          <v-card outlined>
            <v-img :src="imageURL" aspect-ratio="1.75" contain>
              <v-btn text icon dark v-show="false">
                <v-icon>zoom_in</v-icon>
              </v-btn>
            </v-img>
            <uppload-btn @uploadComplete="onUploadComplete">
              <template slot-scope="{ on }">
                <v-btn
                  color="pink"
                  absolute
                  bottom
                  right
                  small
                  fab
                  dark
                  @click="on"
                >
                  <v-icon>mdi-cloud-upload</v-icon>
                </v-btn>
              </template>
            </uppload-btn>
          </v-card>
        </v-flex>
        <v-row v-if="showExternalDomain">
          <v-col cols="4">
            <v-text-field
              label="External Domain"
              v-model="a.externalDomain"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-layout>
    </v-card>
    <slot></slot>
    <v-layout justify-center pt-3>
      <v-btn class="mr-2" @click="onContact"
        ><v-icon>mdi-email</v-icon>Contact</v-btn
      >
      <save-btn v-if="showSave" @click="onSave"></save-btn>
    </v-layout>
    <email-dialog
      :show="showEmailDialog"
      v-model="email"
      @close="showEmailDialog = false"
      @send="onSendMessage"
    ></email-dialog>
    <div v-if="debug">[{{ a.externalDomain }}]</div>
  </v-container>
</template>

<script>
import LanguagesList from "../../gt/shared/LanguageListSelect";
import DepartmentsList from "../../gt/shared/DepartmentListSelect";
import AgentTypeListSelect from "../../gt/shared/AgentTypeListSelect";

import { required, email } from "vuelidate/lib/validators";
import UpploadBtn from "../shared/contents/UpploadBtn";
import SaveBtn from "../shared/SaveButton";
import { SEND_CLIENT_MESSAGE } from "../../../constants/graphql";
import EmailDialog from "../shared/EmailDialog.vue";
export default {
  name: "AgentEditorDetails",

  props: {
    agent: {
      type: Object,
      default: () => ({}),
    },
    save: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    LanguagesList,
    DepartmentsList,
    AgentTypeListSelect,
    UpploadBtn,
    SaveBtn,
    EmailDialog,
  },

  data() {
    return {
      debug: false,
      a: { ...this.agent },
      loading: false,
      image: this.agent ? this.agent.image : "",
      showEmailDialog: false,
      email: null,
    };
  },

  computed: {
    showSave() {
      return (
        !this.$store.getters.hasAccessTo("agents:view_only") &&
        this.$store.getters.hasAccessTo("agents:edit_agent")
      );
    },
    showExternalDomain() {
      return this.$store.getters.hasAccessTo("agents:edit_external_domain");
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    nameErrors() {
      var errors = [];
      if (!this.$v.a.name.$dirty) return errors;
      !this.$v.a.name.required && errors.push("Name is required.");
      return errors;
    },
    emailErrors() {
      var errors = [];
      if (!this.$v.a.email.$dirty) return errors;
      !this.$v.a.email.required && errors.push("Email is required.");
      !this.$v.a.email.email && errors.push("Input must be an email.");
      return errors;
    },

    imageURL() {
      return this.image && this.image != ""
        ? this.image
        : "https://via.placeholder.com/800x600.png?text=Agent%20Logo";
    },
  },

  watch: {
    agent(data) {
      if (JSON.stringify(data) != JSON.stringify(this.a)) {
        this.a = { ...data };
      }
      this.image = data.image ? data.image : "";
    },
    a: {
      handler(data) {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          this.$emit("onChange", data);
        }
      },

      deep: true,
    },
  },

  methods: {
    onContact() {
      this.email = {
        emailTo: this.a.email,
        message: "",
      };
      this.showEmailDialog = true;
    },
    onSendMessage(payload) {
      this.$apollo
        .mutate({
          mutation: SEND_CLIENT_MESSAGE,
          variables: { input: { ...payload } },
        })
        .then((res) => {
          if (res.data.contactClient.success) {
            this.$store.dispatch("showAppSnackbar", {
              msg: "Message Sent",
            });
            this.showEmailDialog = false;
          } else {
            //res.data.ContactClient.success
            this.$store.dispatch("showAppSnackbar", {
              msg: res.data.contactClient.error,
              color: "error",
            });
          }
        })
        .catch((err) => {
          //console.log(err);
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
          console.log(err);
        });
    },
    onLanguageSelect(payload) {
      this.a.languageId = payload;
    },
    onDepartmentSelect(payload) {
      this.a.department = payload.name;
    },
    onSave() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("onSave");
      }
    },
    onUploadComplete(payload) {
      if (payload.success) {
        this.image = payload.fileURL;
        this.a = { ...this.a, image: payload.fileURL };
      }
    },
  },
  validations: {
    a: {
      name: { required },
      email: { required, email },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/agents/AgentEditorDetails.vue